<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  @click="$router.go(-1)"
                    style="cursor: pointer;"
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-backburger
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
    
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 6px;">
                  <v-card-text>
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <!-- <v-stepper v-model="step_index" flat>
                          <v-stepper-header>
                            <v-stepper-step
                              :complete="step_index > 1"
                              step="1"
                            >
                              Informasi Pribadi
                            </v-stepper-step>
      
                            <v-divider></v-divider>
      
                            <v-stepper-step
                              :complete="step_index > 2"
                              step="2"
                            >
                              Informasi Alamat
                            </v-stepper-step>
                          </v-stepper-header>
  
                          <v-divider></v-divider>
                        </v-stepper> -->

                        <v-row justify="center">
                          <v-col cols="12" md="5" class="py-0">
                            <v-stepper v-model="step_index" flat>
                              <v-stepper-header>
                                <v-stepper-step
                                  :complete="step_index > 1"
                                  step="1"
                                >
                                  Informasi Pribadi
                                </v-stepper-step>
          
                                <v-divider></v-divider>
          
                                <v-stepper-step
                                  :complete="step_index > 2"
                                  step="2"
                                >
                                  Informasi Alamat
                                </v-stepper-step>
                              </v-stepper-header>
                            </v-stepper>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
  
                        <div class="pa-5">
                          <div step="1" v-if="step_index === 1">
                            <ValidationProvider 
                              name="Sekolah"
                              rules="required"  
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Sekolah
                                <span class="red--text">*</span>
                              </div>
          
                              <v-autocomplete
                                v-on:keyup.enter="save()"
          
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Contoh. SMP"
          
                                :readonly="user.school_id !== undefined && user.school_id !== null ? true : false"
          
                                :items="school"
                                item-text="name"
                                item-value="id"
                                :item-color="set_color"
          
                                v-model="form.school_id"
                                class="mb-0"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider>

                            <v-card 
                              flat
                              class="mb-5">
                              <v-card-text class="px-1 py-0">
                                <div cclass="fs-13">
                                  Foto Siswa
                                </div>
                                <v-row>
                                  <v-col class="pb-0" cols="2">
                                    <uploadfolder
                                      v-model="upload.image" 
                                      style="height: 150px; width: 100%">
                                      <div 
                                        slot="activator"
                                        class="cursor-pointer">
                                        <v-card 
                                          flat
                                          height="150"
                                          class="d-flex align-center justify-center"
                                          style="border-radius: 15px;
                                                border: 2px solid #eaeaea; 
                                                border-style: dashed;">
                                          <div v-if="form.image_url.length < 1">
                                            <v-icon v-if="!process.image"
                                              size="50" 
                                              color="#868b93">
                                              mdi-plus-circle-outline
                                            </v-icon>
                    
                                            <v-progress-circular v-else
                                              indeterminate
                                              :color="set_color">
                                            </v-progress-circular>
                                          </div>
                    
                                          <v-img v-else
                                            contain
                                            height="150"
                                            :src="form.image_url" 
                                            :alt="form.image_url"
                                            class="text-center d-flex align-center">
                                            <div 
                                              class="d-flex aling-center justify-center" 
                                              style="width: 100%; height: auto;">
                                              <v-icon v-if="!process.image"
                                                size="50" 
                                                color="white">
                                                mdi-plus-circle-outline
                                              </v-icon>
                    
                                              <v-progress-circular v-else
                                                indeterminate
                                                :color="set_color">
                                              </v-progress-circular>
                                            </div>
                                          </v-img>
                                        </v-card>
                                      </div>
                                    </uploadfolder>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
  
                            <ValidationProvider 
                              name="Nama Siswa"
                              rules="required"  
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Nama Siswa
                                <span class="red--text">*</span>
                              </div>
          
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Contoh. xxxxxxxxx"
          
                                
          
                                v-model="form.name"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-text-field>
                            </ValidationProvider>
    
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Kode NISN" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Kode NISN
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense
                                    type="number"
              
                                    :color="set_color"
                                    placeholder="Kode NISN"
              
                                    
              
                                    v-model="form.code"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
          
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="NIK" 
                                  rules="" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    NIK
                                    
                                  </div>
              
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Contoh. xxxxxxxxx"
              
                                    type="number"
                                    min="0"
              
                                    v-model="form.nik"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
  
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Jenis Kelamin" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Jenis Kelamin
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
                                    :items="[
                                      {
                                        text: 'Laki-laki',
                                        value: 'Laki-laki'
                                      },
                                      {
                                        text: 'Perempuan',
                                        value: 'Perempuan'
                                      }
                                    ]"
                                    item-value="value"
                                    item-text="text"
          
                                    :color="set_color"
                                    placeholder="Contoh. Laki-laki"
          
                                    
          
                                    v-model="form.gender"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Agama" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Agama
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Agama"
                                    :items="[
                                      'Islam', 'Kristen', 'Katolik', 'Hindu', 'Budha', 'Konghucu'
                                    ]"
              
                                    v-model="form.religion"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Tempat Lahir" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Tempat Lahir
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Contoh. xxxxxxxxx"
              
                                    v-model="form.birth_place"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Tanggal Lahir" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Tanggal Lahir
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Tanggal Lahir"
                                    type="date"
              
                                    v-model="form.birth_date"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
  
                            <v-divider class="mb-2 mt-1"></v-divider>
  
                            <div class="d-flex align-center mt-4">
                              <div class="fs-14 font-weight-bold">
                                Data Periodik Siswa
                                <span v-if="form.tinggi_badan !== '' || form.berat_badan !== '' || form.jarak_rumah !== '' || form.waktu_tempuh !== '' || form.jumlah_saudara_kandung !== ''">
                                  <v-icon size="16" class="" :color="set_color">mdi-checkbox-marked</v-icon>
                                </span>
                              </div>
                              <div class="ml-auto">
                                <v-btn
                                  @click="show_periodik = !show_periodik"
                                  elevation="0"
                                  :color="set_color"
                                  rounded
                                  small
                                  class="white--text text-capitalize"
                                  style="border-radius: 6px;">
                                  {{ show_periodik ? 'Sembunyikan' : 'Tampilkan' }}
                                </v-btn>
                              </div>
                            </div>
                            <div v-if="show_periodik">
                              <v-row>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Tinggi Badan" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Tinggi Badan
                                      
                                    </div>
                
                                    <v-currency-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                
                                      :color="set_color"
                                      :allow-negative="false"
                                      suffix="cm"
                                      placeholder="Tinggi Badan"
                
                                      v-model="form.tinggi_badan"
                                      :error-messages="errors"
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-currency-field>
                                  </ValidationProvider>
  
  
                                  <ValidationProvider 
                                    name="Berat Badan" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Berat Badan
                                      
                                    </div>
                
                                    <v-currency-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      suffix="kg"
    
                                      :allow-negative="false"
                
                                      :color="set_color"
                                      placeholder="Berat Badan"
    
                
                                      v-model="form.berat_badan"
                                      :error-messages="errors"
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-currency-field>
                                  </ValidationProvider>
  
                                  <ValidationProvider 
                                    name="Jumlah Saudara Kandung" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Jumlah Saudara Kandung
                                      
                                    </div>
                
                                    <v-currency-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      :allow-negative="false"
                                      suffix="orang"
                
                                      :color="set_color"
                                      placeholder="Jumlah Saudara Kandung"
                
                                      v-model="form.jumlah_saudara_kandung"
                                      :error-messages="errors"
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-currency-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Jarak Rumah" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Jarak Rumah
                                      
                                    </div>
                
                                    <v-autocomplete
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      suffix="km"
    
                                      :allow-negative="false"
                
                                      :color="set_color"
                                      placeholder="Jarak Rumah"
                                      :items="[
                                        {
                                          text: 'Kurang dari 1 km',
                                          value: 'Kurang dari 1 km'
                                        },
                                        {
                                          text: 'Lebih dari 1 km',
                                          value: 'Lebih dari 1 km',
                                        },
                                        {
                                          text: 'Lainnya',
                                          value: 'Lainnya',
                                        }
                                      ]"
                
                                      v-model="form.jarak_rumah"
                                      :error-messages="errors"  
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-autocomplete>
                                  </ValidationProvider>
  
                                  <div v-if="form.jarak_rumah === 'Lainnya'">
                                    <ValidationProvider 
                                      name="Jarak Rumah" 
                                      rules="" 
                                      v-slot="{ errors }">
                                      <div class="fs-13 mb-1">
                                        
                                        Jarak Rumah
                                        
                                      </div>
                  
                                      <v-currency-field
                                        v-on:keyup.enter="save()"
                                        
                                        solo
                                        rounded
                                        dense
                                        suffix="km"
      
                                        :allow-negative="false"
                  
                                        :color="set_color"
                                        placeholder="Jarak Rumah"
                  
                                        v-model="form.jarak_rumah_km"
                                        :error-messages="errors"  
                                        style="border-radius: 10px;"
                                        class="mb-0">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>
  
                                  <ValidationProvider 
                                    name="Waktu Tempuh" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Waktu Tempuh
                                      
                                    </div>
                
                                    <v-currency-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      suffix="menit"
    
                                      :allow-negative="false"
                                      :color="set_color"
                                      placeholder="Waktu Tempuh"
                
                                      v-model="form.waktu_tempuh"
                                      :error-messages="errors"
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-currency-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
    
                            </div>
  
                            <!-- <v-divider class="mt-4"></v-divider>
    
                            <div class="d-flex align-center mt-4">
                              <div class="fs-14 font-weight-bold">
                                Data Ayah Kandung
                                <span v-if="form.father_status !== '' || form.father_name !== '' || form.father_birth_place !== '' || form.father_birth_date !== '' || form.father_last_education !== '' || form.father_job !== '' || form.father_phone_number !== '' || form.father_address !== '' || form.father_penghasilan !== 0">
                                  <v-icon size="16" class="" :color="set_color">mdi-checkbox-marked</v-icon>
                                </span>
                              </div>
                              <div class="ml-auto">
                                <v-btn
                                  @click="show_ayah_kandung = !show_ayah_kandung"
                                  elevation="0"
                                  :color="set_color"
                                  rounded
                                  small
                                  class="white--text text-capitalize"
                                  style="border-radius: 6px;">
                                  {{ show_ayah_kandung ? 'Sembunyikan' : 'Tampilkan' }}
                                </v-btn>
                              </div>
                            </div>
                            <div v-if="show_ayah_kandung" class="mt-2">
                              <ValidationProvider 
                                name="Status Ayah" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Status Ayah
                                </div>
        
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
  
                                  :items="[
                                    {
                                      text: 'Ada',
                                      value: 'Ada'
                                    },
                                    {
                                      text: 'Sudah Meninggal',
                                      value: 'Sudah Meninggal'
                                    },
                                    {
                                      text: 'Tidak Ada',
                                      value: 'Tidak Ada'
                                    }
                                  ]"
                                  item-value="value"
                                  item-text="text"
        
                                  :color="set_color"
                                  placeholder="Contoh. xxxxxxxxx"
                                  v-model="form.father_status"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-autocomplete>
                              </ValidationProvider>
                              <ValidationProvider 
                                name="Nama Ayah" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nama Ayah
                                </div>
        
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Contoh. xxxxxxxxx"
                                  v-model="form.father_name"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                              <v-row>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Tempat Lahir Ayah" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Tempat Lahir Ayah
                                    </div>
            
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.father_birth_place"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Tanggal Lahir Ayah" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Tanggal Lahir Ayah
                                    </div>
            
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
            
                                      :color="set_color"
                                      placeholder="Tanggal Lahir Ayah"
                                      type="date"
                                      
                                      v-model="form.father_birth_date"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Pendidikan Terakhir Ayah" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Pendidikan Terakhir Ayah
                                    </div>
            
                                    <v-autocomplete
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      :items="[
                                        {
                                          text: 'Tidak Sekolah',
                                          value: 'Tidak Sekolah'
                                        },
                                        {
                                          text: 'SD/Sederajat',
                                          value: 'SD/Sederajat'
                                        },
                                        {
                                          text: 'SMP/Sederajat',
                                          value: 'SMP/Sederajat'
                                        },
                                        {
                                          text: 'SMA/Sederajat',
                                          value: 'SMA/Sederajat'
                                        },
                                        {
                                          text: 'Diploma (D1)',
                                          value: 'Diploma (D1)'
                                        },
                                        {
                                          text: 'Diploma (D2)',
                                          value: 'Diploma (D2)'
                                        },
                                        {
                                          text: 'Diploma (D3)',
                                          value: 'Diploma (D3)'
                                        },
                                        {
                                          text: 'Diploma (D4)',
                                          value: 'Diploma (D4)'
                                        },
                                        {
                                          text: 'Sarjana (S1)',
                                          value: 'Sarjana (S1)'
                                        },
                                        {
                                          text: 'Magister (S2)',
                                          value: 'Magister (S2)'
                                        },
                                        {
                                          text: 'Doktor (S3)',
                                          value: 'Doktor (S3)'
                                        }
                                      ]"
                                      item-value="value"
                                      item-text="text"
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.father_last_education"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Pekerjaan Ayah" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Pekerjaan Ayah
                                    </div>
            
                                    <v-autocomplete
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      :items="[
                                        'Pegawai Negeri Sipil', 'TNI/POLRI', 'Guru/Dosen', 'Karyawan Swasta', 'Karyawan BUMN/BUMD', 'Tenaga Medis', 'Pegawai Bank', 'Notaris/Pengacara', 'Petani/Pembudidaya', 'Pedagang', 'Nelayan', 'Tukang', 'Sopir/Ojek Online', 'Buruh Harian', 'Wiraswasta', 'Freelancer', 'Konsultan', 'Seniman', 'Influencer', 'Penjahit', 'Montir', 'Koki', 'Pemandu Wisata', 'Petugas Kebersihan', 'Ibu Rumah Tangga', 'Asisten Rumah Tangga', 'Tidak Bekerja', 'Pensiunan', 'Mahasiswa'
                                      ]"
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.father_job"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="No Telephone Ayah" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      No Telephone Ayah
                                    </div>
            
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      type="number"
                                      min="0"
                                      prefix="+62"
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.father_phone_number"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Pengahasilan Ayah" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Pengahasilan Ayah
                                    </div>
            
                                    <v-currency-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
            
                                      :color="set_color"
                                      :allow-negative="false"
                                      prefix="Rp. "
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.father_penghasilan"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-currency-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <ValidationProvider 
                                name="Alamat Ayah" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Alamat Ayah
                                </div>
        
                                <v-textarea
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Contoh. Jl. xxxxxxx"
        
                                  v-model="form.father_address"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-textarea>
                              </ValidationProvider>
                            </div>
  
                            <v-divider class="mt-4"></v-divider>
    
                            <div class="d-flex align-center mt-4">
                              <div class="fs-14 font-weight-bold">
                                Data Ibu Kandung
                                <span v-if="form.mother_status !== '' || form.mother_name !== '' || form.mother_birth_place !== '' || form.mother_birth_date !== '' || form.mother_last_education !== '' || form.mother_job !== '' || form.mother_phone_number !== '' || form.mother_address !== '' || form.mother_penghasilan !== 0">
                                  <v-icon size="16" class="" :color="set_color">mdi-checkbox-marked</v-icon>
                                </span>
                              </div>
                              <div class="ml-auto">
                                <v-btn
                                  @click="show_ibu_kandung = !show_ibu_kandung"
                                  elevation="0"
                                  :color="set_color"
                                  rounded
                                  small
                                  class="white--text text-capitalize"
                                  style="border-radius: 6px;">
                                  {{ show_ibu_kandung ? 'Sembunyikan' : 'Tampilkan' }}
                                </v-btn>
                              </div>
                            </div>
  
                            <div v-if="show_ibu_kandung" class="mt-2">
                              <ValidationProvider 
                                name="Status Ibu" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Status Ibu
                                </div>
        
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
  
                                  :items="[
                                    {
                                      text: 'Ada',
                                      value: 'Ada'
                                    },
                                    {
                                      text: 'Sudah Meninggal',
                                      value: 'Sudah Meninggal'
                                    },
                                    {
                                      text: 'Tidak Ada',
                                      value: 'Tidak Ada'
                                    }
                                  ]"
                                  item-value="value"
                                  item-text="text"
        
                                  :color="set_color"
                                  placeholder="Contoh. xxxxxxxxx"
                                  v-model="form.mother_status"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-autocomplete>
                              </ValidationProvider>
                              <ValidationProvider 
                                name="Nama Ibu" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nama Ibu
                                </div>
        
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Contoh. xxxxxxxxx"
                                  v-model="form.mother_name"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                              <v-row>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Tempat Lahir Ibu" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Tempat Lahir Ibu
                                    </div>
            
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.mother_birth_place"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Tanggal Lahir Ibu" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Tanggal Lahir Ibu
                                    </div>
            
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
            
                                      :color="set_color"
                                      placeholder="Tanggal Lahir Ibu"
                                      type="date"
                                      
                                      v-model="form.mother_birth_date"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Pendidikan Terakhir Ibu" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Pendidikan Terakhir Ibu
                                    </div>
            
                                    <v-autocomplete
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      :items="[
                                        {
                                          text: 'Tidak Sekolah',
                                          value: 'Tidak Sekolah'
                                        },
                                        {
                                          text: 'SD/Sederajat',
                                          value: 'SD/Sederajat'
                                        },
                                        {
                                          text: 'SMP/Sederajat',
                                          value: 'SMP/Sederajat'
                                        },
                                        {
                                          text: 'SMA/Sederajat',
                                          value: 'SMA/Sederajat'
                                        },
                                        {
                                          text: 'Diploma (D1)',
                                          value: 'Diploma (D1)'
                                        },
                                        {
                                          text: 'Diploma (D2)',
                                          value: 'Diploma (D2)'
                                        },
                                        {
                                          text: 'Diploma (D3)',
                                          value: 'Diploma (D3)'
                                        },
                                        {
                                          text: 'Diploma (D4)',
                                          value: 'Diploma (D4)'
                                        },
                                        {
                                          text: 'Sarjana (S1)',
                                          value: 'Sarjana (S1)'
                                        },
                                        {
                                          text: 'Magister (S2)',
                                          value: 'Magister (S2)'
                                        },
                                        {
                                          text: 'Doktor (S3)',
                                          value: 'Doktor (S3)'
                                        }
                                      ]"
                                      item-value="value"
                                      item-text="text"
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.mother_last_education"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Pekerjaan Ibu" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Pekerjaan Ibu
                                    </div>
            
                                    <v-autocomplete
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      :items="[
                                        'Pegawai Negeri Sipil', 'TNI/POLRI', 'Guru/Dosen', 'Karyawan Swasta', 'Karyawan BUMN/BUMD', 'Tenaga Medis', 'Pegawai Bank', 'Notaris/Pengacara', 'Petani/Pembudidaya', 'Pedagang', 'Nelayan', 'Tukang', 'Sopir/Ojek Online', 'Buruh Harian', 'Wiraswasta', 'Freelancer', 'Konsultan', 'Seniman', 'Influencer', 'Penjahit', 'Montir', 'Koki', 'Pemandu Wisata', 'Petugas Kebersihan', 'Ibu Rumah Tangga', 'Asisten Rumah Tangga', 'Tidak Bekerja', 'Pensiunan', 'Mahasiswa'
                                      ]"
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.mother_job"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="No Telephone Ibu" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      No Telephone Ibu
                                    </div>
            
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      type="number"
                                      min="0"
                                      prefix="+62"
            
                                      :color="set_color"
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.mother_phone_number"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                  <ValidationProvider 
                                    name="Pengahasilan Ibu" 
                                    rules="" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Pengahasilan Ibu
                                    </div>
            
                                    <v-currency-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
            
                                      :color="set_color"
                                      :allow-negative="false"
                                      prefix="Rp. "
                                      placeholder="Contoh. xxxxxxxxx"
                                      v-model="form.mother_penghasilan"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-currency-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <ValidationProvider 
                                name="Alamat Ibu" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Alamat Ibu
                                </div>
        
                                <v-textarea
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Contoh. Jl. xxxxxxx"
        
                                  v-model="form.mother_address"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-textarea>
                              </ValidationProvider>
                            </div> -->
                          </div>
  
    
                          <div step="3" v-if="step_index === 2">
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Provinsi"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Provinsi
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Provinsi"
              
                                    
              
                                    :items="province"
                                    v-on:change="changeProvince()"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.province_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Kota / Kabupaten"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Kota / Kabupaten
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Kota / Kabupaten"
              
                                    
              
                                    :items="city"
                                    v-on:change="changeCity()"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.city_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Kecamatan"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Kecamatan
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    v-on:change="changeSub()"
                                    placeholder="Pilih Kecamatan"
              
                                    
              
                                    :items="subdistrict"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.subdistrict_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Kelurahan"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Kelurahan
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Kelurahan"
              
                                    :items="village"
                                    v-on:change="village.filter(item =>item.id === form.village_id).map(item => form.village_name = item.name)"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.village_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
  
                            <ValidationProvider 
                              name="Alamat" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Alamat
                                <span class="red--text">*</span>
                              </div>
          
                              <v-textarea
                                v-on:keyup.enter="save()"
                                
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Contoh. Jl. xxxxxxx"
          
                                v-model="form.address"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-textarea>
                            </ValidationProvider>
  
                            <div
                              class="mb-6">
                              <div 
                                class="body-2 mb-2">
                                Silahkan geser marker untuk menentukan koordinat lokasi dibawah ini:
                              </div>
          
                              <label>
                                <gmap-autocomplete
                                  placeholder="ketik alamat"
                                  class="style-auto-map mb-4"
                                  @place_changed="setPlace">
                                </gmap-autocomplete>
                              </label>
          
                              <gmap-map
                                :center="center"
                                :zoom="12"
                                :options="{
                                  zoomControl: true,
                                  mapTypeControl: false,
                                  scaleControl: false,
                                  streetViewControl: false,
                                  rotateControl: false,
                                  fullscreenControl: true,
                                  disableDefaultUi: false
                                }"
                                :clickable="true"
                                @click="updatePlace"
                                style="width: 100%; height: 400px;">
          
                                <gmap-marker
                                  :position="center"
                                  :draggable="true"
                                  @drag="updatePlace"
                                  @click="center=center">
                                </gmap-marker>
                              </gmap-map>

                              <v-row class="mt-3">
                                <v-col cols="12" md="6">
                                  <ValidationProvider 
                                    name="Latitude" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Latitude
                                      <span class="red--text">*</span>
                                    </div>
                
                                    <v-text-field
                                      solo
                                      rounded
                                      dense
                                      type="number"
                                      min="0"
                                      v-on:change="updatePlaceFromMap()"
                                      :color="set_color"
                                      placeholder="Tentukan Latitude"
                
                                      v-model="form.latitude"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <ValidationProvider 
                                    name="Longitude" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Longitude
                                      <span class="red--text">*</span>
                                    </div>
                
                                    <v-text-field
                                      solo
                                      rounded
                                      dense
                                      type="number"
                                      min="0"
                                      v-on:change="updatePlaceFromMap()"
                                      :color="set_color"
                                      placeholder="Tentukan Longitude"
                
                                      v-model="form.longitude"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>
                      </v-form>
                    </ValidationObserver>
                    <div v-if="message.error.length > 0"
                      class="text-left mt-0">
                      <div
                        class="error--text d-flex align-start">
                        <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pa-5">
                    <v-btn
                      @click="step_index = step_index - 1"
                      :disabled="process.form"
                      elevation="0"
                      :color="set_color"
                      dark
                      v-if="step_index > 1"
                      rounded
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Sebelumnya
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                      @click="toNextStep()"
                      :disabled="process.form"
                      elevation="0"
                      :color="set_color"
                      dark
                      v-if="step_index < 2"
                      rounded
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Selanjutnya
                    </v-btn>
  
                    <v-btn
                      @click="save()"
                      :disabled="process.form"
                      dark
                      v-if="step_index === 2"
                      elevation="0"
                      :color="set_color"
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Simpan
                    </v-btn>
  
                    <v-btn
                      to="/manajemen-akademik/data-pengguna/data-siswa"
                      :disabled="process.form"
                      width="85"
                      outlined
                      elevation="0"
                      color="red"
                      style="border-radius: 6px;"
                      class="fs-13 font-weight-bold text-capitalize white--text">
                      Batal
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          filter: {
            school_id: '',
          },
          show_periodik: false,
          show_ayah_kandung: false,
          show_ibu_kandung: false,
          step_index: 1,
          form: {
            id: '',
            school_id: '',
            code: '',
            name: '',
            nik: '',
            gender: '',
            birth_place: '',
            birth_date: '',
            religion: '',
            province_id: '',
            province_name: '',
            city_id: '',
            city_name: '',
            subdistrict_id: '',
            subdistrict_name: '',
            dusun_name: '',
            address: '',
            rt_rw: '',
            village_id: '',
            village_name: '',
            mobile_phone_number: '',
            father_status: '',
            father_name: '',
            father_birth_place: '',
            father_birth_date: '',
            father_last_education: '',
            father_job: '',
            father_phone_number: '',
            father_address: '',
            father_penghasilan: 0,
            mother_status: '',
            mother_name: '',
            mother_birth_place: '',
            mother_birth_date: '',
            mother_last_education: '',
            mother_job: '',
            mother_phone_number: '',
            mother_address: '',
            mother_penghasilan: 0,
            tinggi_badan: '',
            berat_badan: '',
            jarak_rumah: '',
            jarak_rumah_km: 0,
            waktu_tempuh: '',
            jumlah_saudara_kandung: '',
            image_url: '',
            longitude: '',
            latitude: '',
          },
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },
          
          upload: {
            image: '',
            banner_url: null,
            galery_array: null
          },
          province: [],
          city: [],
          subdistrict: [],
          school: [],
          village: [],
          kurikulum: [],
  
          process: {
            load: false,
            image: false,
            form: false,
            banner_url: false,
            galery_array: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.banner_url': {
          handler: function () {
            if (this.upload.banner_url) {
              this.process.banner_url = this.upload.banner_url.process
  
              if (!this.process.banner_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.banner_url = this.upload.banner_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.galery_array': {
          handler: function () {
            if (this.upload.galery_array) {
              this.process.galery_array = this.upload.galery_array.process
  
              if (!this.process.galery_array) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.galery_array.push({
                  galery_url: this.upload.galery_array.fileuri,
                  galery_desc: ''
                })
  
                // this.save_image()
  
                this.upload.galery_array = null
              }
            }
          },
          deep: true
        },
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        token () {
          return this.$store.state.token
        },
        user () {
          return this.$store.state.user
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted () {
        this.fetchProv()
        this.fetchDetail()
      },
      methods: {
        async fetchDetail() {
          this.process.load = true
          let params = {
            id: this.$route.params.id,
            school_id: this.$route.params.school_id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/siswa/detail' : 'siswa/detail'

          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              // this.kurikulum = res.results.data
              this.form.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
              this.form = {
                id: res.results.data.id,
                school_id: this.$route.params.school_id,
                code: res.results.data.code,
                name: res.results.data.name,
                nik: res.results.data.nik,
                gender: res.results.data.gender,
                birth_place: res.results.data.birth_place,
                birth_date: res.results.data.birth_date,
                religion: res.results.data.religion,
                province_id: res.results.data.province_id,
                city_id: res.results.data.city_id,
                subdistrict_id: res.results.data.subdistrict_id,
                dusun_name: res.results.data.dusun_name,
                address: res.results.data.address,
                rt_rw: res.results.data.rt_rw,
                village_id: res.results.data.village_id,
                mobile_phone_number: res.results.data.mobile_phone_number,
                father_status: res.results.data.father_status,
                father_name: res.results.data.father_name,
                father_birth_place: res.results.data.father_birth_place,
                father_birth_date: res.results.data.father_birth_date,
                father_last_education: res.results.data.father_last_education,
                father_job: res.results.data.father_job,
                father_phone_number: res.results.data.father_phone_number,
                father_address: res.results.data.father_address,
                father_penghasilan: res.results.data.father_penghasilan,
                mother_status: res.results.data.mother_status,
                mother_name: res.results.data.mother_name,
                mother_birth_place: res.results.data.mother_birth_place,
                mother_birth_date: res.results.data.mother_birth_date,
                mother_last_education: res.results.data.mother_last_education,
                mother_job: res.results.data.mother_job,
                mother_phone_number: res.results.data.mother_phone_number,
                mother_address: res.results.data.mother_address,
                mother_penghasilan: res.results.data.mother_penghasilan,
                tinggi_badan: res.results.data.tinggi_badan,
                berat_badan: res.results.data.berat_badan,
                jarak_rumah: res.results.data.jarak_rumah,
                jarak_rumah_km: res.results.data.jarak_rumah_km,
                waktu_tempuh: res.results.data.waktu_tempuh,
                jumlah_saudara_kandung: res.results.data.jumlah_saudara_kandung,
                province_name: res.results.data.province_name,
                city_name: res.results.data.city_name,
                subdistrict_name: res.results.data.subdistrict_name,
                village_name: res.results.data.village_name,
                image_url: res.results.data.image_url,
                longitude: res.results.data.longitude,
                latitude: res.results.data.latitude
              }

              res.results.data.family.map(item => {
                if (item.siswa_family_relation === 'Ayah Kandung') {
                  this.form.father_status = item.siswa_family_status
                  this.form.father_name = item.siswa_family_name
                  this.form.father_birth_place = item.siswa_family_birth_place
                  this.form.father_birth_date = item.siswa_family_birth_date
                  this.form.father_last_education = item.siswa_family_last_education
                  this.form.father_job = item.siswa_family_job
                  this.form.father_phone_number = item.siswa_family_phone_number
                  this.form.father_address = item.siswa_family_address
                  this.form.father_penghasilan = item.siswa_family_penghasilan
                } else if (item.siswa_family_relation === 'Ibu Kandung') {
                  this.form.mother_status = item.siswa_family_status
                  this.form.mother_name = item.siswa_family_name
                  this.form.mother_birth_place = item.siswa_family_birth_place
                  this.form.mother_birth_date = item.siswa_family_birth_date
                  this.form.mother_last_education = item.siswa_family_last_education
                  this.form.mother_job = item.siswa_family_job
                  this.form.mother_phone_number = item.siswa_family_phone_number
                  this.form.mother_address = item.siswa_family_address
                  this.form.mother_penghasilan = item.siswa_family_penghasilan
                }
              })

              this.form.jarak_rumah = res.results.data.jarak_rumah === 'Kurang dari 1 km' || res.results.data.jarak_rumah === 'Lebih dari 1 km' ? res.results.data.jarak_rumah : 'Lainnya'
              this.form.jarak_rumah_km = res.results.data.jarak_rumah === 'Kurang dari 1 km' || res.results.data.jarak_rumah === 'Lebih dari 1 km' ? '' : res.results.data.jarak_rumah

              this.center = {
                lat: res.results.data.latitude*1,
                lng: res.results.data.longitude*1
              }
              this.fetchSchool()
              this.fetchCity(res.results.data.province_id)
              this.fetchSub(res.results.data.city_id)
              this.fetchVillage(res.results.data.subdistrict_id)

              this.process.load = false
            }
          })
        },
        async fetchSchool() {
    
            let params = {
            limit: 10000000000000
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.school = res.results.data
            }
          })
        },
  
        async fetchProv() {
  
           let params = {
            limit: 10000000000000
          }
  
  
          await get(`ref/provinsi`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.province = res.results.data
            }
          })
        },
  
        changeProvince() {
          this.form.city_id = ''
          this.form.city_name = ''
          this.form.subdistrict_id = ''
          this.form.subdistrict_name = ''
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.province.map(obj => {
            if (obj.id === this.form.province_id) {
              id = obj.id
              this.form.province_name = obj.name
            }
          })
          this.fetchCity(id)
        },
  
        async fetchCity(id) {
  
           let params = {
            limit: 10000000000000,
            province_id: id
          }
  
          await get(`ref/kota`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.city = res.results.data
            }
          })
        },
  
        changeCity() {
          this.form.subdistrict_id = ''
          this.form.subdistrict_name = ''
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.city.map(obj => {
            if (obj.id === this.form.city_id) {
              id = obj.id
              this.form.city_name = obj.name
            }
          })
          this.fetchSub(id)
        },
  
        async fetchSub(id) {
  
           let params = {
            limit: 10000000000000,
            city_id: id
          }
  
          await get(`ref/kecamatan`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.subdistrict = res.results.data
            }
          })
        },
  
        changeSub() {
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.subdistrict.map(obj => {
            if (obj.id === this.form.subdistrict_id) {
              id = obj.id
              this.form.subdistrict_name = obj.name
            }
          })
          this.fetchVillage(id)
        },
  
        async fetchVillage(id) {
  
           let params = {
            limit: 10000000000000,
            subdistrict_id: id
          }
  
          await get(`ref/kelurahan`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.village = res.results.data
            }
          })
        },
  
        setPlace(place) {
          this.place = place
          this.center = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          
          }
            // this.initMap()
          this.form.latitude = this.place.geometry.location.lat()
          this.form.longitude = this.place.geometry.location.lng()
        },
        getGeoLocation() {
          if (this.form.id === '') {
            navigator.geolocation.getCurrentPosition(position => {
              this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
            })
          } else {
            this.center = {
              lat: this.form.latitude,
              lng: this.form.longitude
            }
          }
        },
        updatePlace(location) {
          this.center = {
            lat: location.latLng.lat(),
            lng: location.latLng.lng()
          }
  
          this.form.latitude = location.latLng.lat()
          this.form.longitude = location.latLng.lng()
        },

        updatePlaceFromMap() {
          this.center = {
            lat: this.form.latitude*1,
            lng: this.form.longitude*1
          }
        },
  
        async toNextStep  () {
          this.message.error = ''
          this.$refs.form.validate().then(success => {
            if (success) {
              this.step_index = this.step_index + 1
            if (this.$refs.form) this.$refs.form.reset()
            }
          })
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true
  
            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.id === '' ? 'pegawai/siswa/add' : 'pegawai/siswa/update' : this.form.id === '' ? 'siswa/add' : 'siswa/update'
  
            // SAVE TO REST API
            this.form.jarak_rumah = this.form.jarak_rumah === 'Lainnya' ? this.form.jarak_rumah_km : this.form.jarak_rumah
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
  
                this.$router.push({ path: '/manajemen-akademik/data-pengguna/data-siswa' })
  
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
      },
      created () {
      }
    }
  </script>